import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Currency } from '@app/model/currency';
import { UserService } from '@app/service/user-service/user.service';

@Component({
  selector: 'app-de-collective-invoice-success',
  templateUrl: './de-collective-invoice-success.component.html',
  styleUrls: [
    '../../../../route/page-shared.css',
    './de-collective-invoice-success.component.scss',
  ],
})
export class DeCollectiveInvoiceSuccessComponent implements OnInit {
  @Output() onDetailsClick = new EventEmitter();
  @Input() params: any;
  @Input() email: string;
  @Input() totalCheckoutValue: Currency;
  @Input() state;
  constructor(private userService: UserService) {}

  ngOnInit(): void {
    if (this.state.status !== 'COMPLETED') {
      this.userService.chargeCollectiveInvoice().then((res) => {});
    }
  }

  detailsClick() {
    this.onDetailsClick.emit();
  }
}
